import { IHeaderParams } from 'ag-grid-community';

export function AgHeaderTextCenter(props: IHeaderParams) {
  return <div className="text-center truncate">{props.displayName}</div>;
}
